export var DEFAULT_HEIGHT = '100%';
export var DEFAULT_WIDTH = '100%';